import React, { useState, useRef, useEffect } from "react";

/**
 * Small (i) icon — click or hover shows plain-language help for finance users.
 */
export default function FinanceV2InfoTip({ title, body, source }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("mousedown", close);
    }
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  if (!title && !body) return null;

  return (
    <span className="fv2-info-tip" ref={ref}>
      <button
        type="button"
        className="fv2-info-btn"
        aria-label="More information"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        <i className="bi bi-info-circle" />
      </button>
      {open && (
        <div className="fv2-info-popover" role="tooltip">
          {title && <div className="fv2-info-popover-title">{title}</div>}
          {body && <p className="fv2-info-popover-body mb-1">{body}</p>}
          {source && (
            <div className="fv2-info-popover-source">
              <strong>Source:</strong> {source}
            </div>
          )}
        </div>
      )}
    </span>
  );
}
